import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { motion } from 'framer-motion';
export interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}
export function Breadcrumb({
  items,
  className = ''
}: BreadcrumbProps) {
  return <nav aria-label="Breadcrumb" className={`flex ${className}`} data-id="element-5187">
      <ol className="flex items-center flex-wrap gap-2 text-sm text-gray-500" data-id="element-5188">
        <motion.li initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-5189">
          <Link to="/" className="flex items-center hover:text-primary-600 transition-colors p-1 rounded-md hover:bg-gray-100" data-id="element-5190">
            <Home className="w-4 h-4" data-id="element-5191" />
            <span className="sr-only" data-id="element-5192">Inicio</span>
          </Link>
        </motion.li>

        {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return <motion.li key={index} initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.3,
          delay: (index + 1) * 0.1
        }} className="flex items-center" data-id="element-5193">
              <ChevronRight className="w-4 h-4 text-gray-300 mx-1 flex-shrink-0" data-id="element-5194" />
              {item.href && !isLast ? <Link to={item.href} className="hover:text-primary-600 transition-colors font-medium whitespace-nowrap px-2 py-1 rounded-md hover:bg-gray-50" data-id="element-5195">
                  {item.label}
                </Link> : <span className={`px-2 py-1 font-bold ${isLast ? 'text-charcoal-900' : 'text-gray-500'} whitespace-nowrap`} aria-current={isLast ? 'page' : undefined} data-id="element-5196">
                  {item.label}
                </span>}
            </motion.li>;
      })}
      </ol>
    </nav>;
}